export default {
    model: {
        email: {
            label: "E-Mail",
            placeholder: "Name oder E-Mail-Adresse des Delegierten",
            notFound: "Benutzer nicht gefunden"
        },
        start_on: {
            label: "Startdatum",
            placeholder: "Datum für den Beginn der Delegation"
        },
        end_on: {
            label: "Enddatum",
            placeholder: "Optional"
        },
        accept: {
            tip: "Mit der Übertragung Ihrer Genehmigungsbefugnis bestätigen Sie, dass Sie die Rechenschaftspflicht und Verantwortung für alle von Ihrem Beauftragten genehmigten Aufträge übernehmen.",
            label: "Ich akzeptiere"
        }
    },
    buttons: {
        submit: {
            cta: "Bestätigen",
            processing: "Sparen"
        },
        close: {
            cta: "Stornieren"
        }
    },
    saved: "Gespeichert"
}